import { showFullCompose } from 'owa-calendar-full-compose/lib/actions/showFullCompose';
import { orchestrator } from 'satcheljs';
import { lazyShowFullComposeInEditMode } from 'owa-calendar-compose-form-store';
import { FULL_COMPOSE_VIEW_TYPE_MODAL } from 'owa-calendar-helpers-types/lib/ComposeTypes';
import { FullComposeEntrySourceType } from 'owa-calendar-helpers-types/lib/ComposeMetricTypes';

// TODO: VSO #88707 Separate module vs surface concerns in Calendar module
// Full compose orchestrator should live in a compose-related package

export default orchestrator(showFullCompose, actionMessage => {
    const { event, entrySource, eventScope } = actionMessage;

    lazyShowFullComposeInEditMode.importAndExecute(
        event,
        eventScope,
        false /* itemHasUpdates */,
        entrySource as FullComposeEntrySourceType,
        FULL_COMPOSE_VIEW_TYPE_MODAL,
        null /* extractionSourceId */
    );
});
